module.exports = __webpack_public_path__ + "img/IMG_1539_L_Wood.560b239d.jpg";